<template>
  <div class="slider" :style="calculatedBackground">
    <div class="row justify-content-center slider-content">
      <div class="col-md-10 col-12">
        <h1 class="title" v-html="$t('landing.slider.title')"></h1>
        <email-validator class="mt-5 w-75"></email-validator>
        <div class="row mt-5 value-added">
          <div class="col-4">
            <router-link
              :to="{ name: 'register' }"
            >
              <div class="icon-box">
                <icon-category-1></icon-category-1>
              </div>
              <span v-html="$t('landing.slider.value_1')"></span>
            </router-link>
          </div>
          <div class="col-4">
            <router-link
              :to="{ name: 'register' }"
            >
              <div class="icon-box">
                <icon-photogram></icon-photogram>
              </div>
              <span v-html="$t('landing.slider.value_2')"></span>
            </router-link>
          </div>
          <div class="col-4">
            <router-link
              :to="{ name: 'register' }"
            >
              <div class="icon-box">
                <icon-screen-bolt></icon-screen-bolt>
              </div>

              <span v-html="$t('landing.slider.value_3')"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mobile-value-added no-gutters">
    <div class="col-4 p-2">
      <router-link
        :to="{ name: 'register' }"
      >
        <div class="icon-box">
          <icon-category-1></icon-category-1>
        </div>
        <p class="benefit" v-html="$t('landing.slider.value_1')"></p>
      </router-link>
    </div>
    <div class="col-4 p-2">
      <router-link
        :to="{ name: 'register' }"
      >
        <div class="icon-box">
          <icon-photogram></icon-photogram>
        </div>

        <p class="benefit" v-html="$t('landing.slider.value_2')"></p>
      </router-link>

    </div>
    <div class="col-4 p-2">
      <router-link
        :to="{ name: 'register' }"
      >
        <div class="icon-box">
          <icon-screen-bolt></icon-screen-bolt>
        </div>

        <p class="benefit" v-html="$t('landing.slider.value_3')"></p>
      </router-link>
    </div>
  </div>
</template>

<script>
import IconPhotogram from "../icons/iconPhotogram.vue";
import IconScreenBolt from "../icons/iconScreenBolt.vue";
import IconCategory from "../icons/iconCategory.vue";
import IconCategory1 from "../icons/iconCategory1.vue";
import EmailValidator from "@/components/landing/partials/EmailValidator.vue";
export default {
  name: "mainSlider",
  components: {
    EmailValidator,
    IconCategory1,
    IconScreenBolt,
    IconPhotogram,
  },
  computed: {
    calculatedBackground() {
      let image = this.isMobile()
        ? "mobilelandb.jpg"
        : "30xpfgx1al44w004scb.jpg";
      let trailing = this.supportsWebP ? ".webp" : "";
      let img = "https://img.flixlatino.com/" + image + trailing;
      return {
        background:
          "linear-gradient(90.13deg,rgba(12, 18, 22, 0.7) 0.1%,rgba(12, 18, 22, 0.336) 99.88%),url(" +
          img +
          ")",
        backgroundSize: "cover",
      };
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.mobile-value-added {
  display: none;
}
@media (max-width: 600px) {
  .mobile-value-added {
    display: flex;
    text-align: center;
    margin-top: 1em;
    width: 100vw;
    .icon-box {
      text-align: center;
      background: linear-gradient(326deg, #202b40 0%, rgba(12, 17, 26, 0) 100%);
      width: 4em;
      height: 4em;
      border-radius: 16px;
      border: 1px solid #202b40;
      display: block !important;
      margin: 0 auto 1em;
      svg {
        fill: #ffffff;
        margin: 1em;
      }
    }
    p {
      font-size: 0.9em;
      color: $secondary;
      line-height: 2em;
    }
  }
}
.slider {
  height: 0px;
  min-height: 375px;
  width: 100%;
  padding: 45%;
  border-radius: 64px;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;

  .slider-content{
    position: absolute;
    top: 0;
    bottom: 0;
    align-items: center;
  }

  .value-added {
    .col-4 {
  
      a{
        display: flex;
        align-items: center;
        color: #fff;
        .icon-box {
          background: #42595a99;
          border-radius: 16px;
          border: 2px solid #42595a;
          display: block !important;
          margin-right: 1em;
          svg {
            width: 24px;
            height: 24px;
            fill: #ffffff;
            margin: 10px;
          }
        }
      }
    }
  }
  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 0.5em;
    font-size: 4.5em;
    line-height: 100%;
    color: #ffffff;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .input-group {
    padding: 0.5em;
    border-radius: 14px;
    background: linear-gradient(
      1.64deg,
      #2e4949 -6.14%,
      rgba(52, 72, 73, 0) 160.73%
    );
    backdrop-filter: blur(16px);

    input {
      background-color: transparent;
      padding: 1.6em;
      border: none;

      &::placeholder {
        color: white;
      }
    }

    button {
      background: $red;
      padding: 0.5em 2em;
    }
  }
  @media (max-width: 600px) {
    border-radius: 0px;
    background-size: contain;
    height: auto;
    margin-bottom: 3em;
    .slider-content{
      align-items: end;
      font-size: 1em;
      width: 100%;
      .title{
        font-size: 2.5em;
      }
    }
    .value-added {
      display: none;
    }
    .input-group {
      &.w-75 {
        margin: auto;
        width: 95% !important;
      }
    }
  }

  @media (max-width: 375px) {
    .slider-content{
      .title{
        font-size: 2em;
      }
    }
  }
}
@media (max-width: 767px) {
  .container.home {
    padding: 0;
  }

  .slider {
    background-size: cover;
    .email-validator {
      width: 100% !important;
      margin: auto;
      padding: 0;
      background: linear-gradient(
        to bottom,
        rgba(23, 30, 53, 0),
        rgba(23, 30, 53, 1)
      );
      &:after {
        content: "";
        position: absolute;
        width: inherit;
        height: inherit;
        background: linear-gradient(to bottom, #0c111b00, #0c111b);
        -webkit-mask-image: linear-gradient(to left, #0c111b, transparent);
      }
    }
  }
}


@media (min-width: 1024px) {
  .slider{
    padding: 25%;
  }

  .slider-content{
    font-size: 1vw;
  }
}

@media (max-width: 800px) {
    .slider-content{
      .title{
        font-size: 4em;
      }
    }
}

</style>
